import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, object=auth
  const [viewFlash, setViewFlash] = useState(null); // {title, sub} — survives route changes
  const [actAs, setActAs] = useState(() => {
    const id = localStorage.getItem("mpl_act_as");
    const name = localStorage.getItem("mpl_act_as_name");
    return id ? { id, name: name || "agent" } : null;
  });

  useEffect(() => {
    const token = localStorage.getItem("mpl_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("mpl_token");
        setUser(null);
      });
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("mpl_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("mpl_token");
    localStorage.removeItem("mpl_act_as");
    localStorage.removeItem("mpl_act_as_name");
    setActAs(null);
    setUser(null);
  };

  const refresh = async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      /* ignore */
    }
  };

  const startActingAs = (agent) => {
    localStorage.setItem("mpl_act_as", agent.id);
    localStorage.setItem("mpl_act_as_name", agent.name || "agent");
    localStorage.setItem("mpl_last_agent_id", agent.id);
    localStorage.setItem("mpl_last_agent_name", agent.name || "agent");
    setActAs({ id: agent.id, name: agent.name || "agent" });
  };

  const stopActingAs = () => {
    localStorage.removeItem("mpl_act_as");
    localStorage.removeItem("mpl_act_as_name");
    setActAs(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh, setUser, actAs, startActingAs, stopActingAs, viewFlash, setViewFlash }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
